var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor",style:({ width: (_vm.editorWidth + "px") }),attrs:{"id":_vm.editorId}},[_c('div',{ref:"toolbar",staticClass:"toolbar"}),_c('div',{ref:"editorContainer",staticClass:"text"})])}
var staticRenderFns = []

export { render, staticRenderFns }